export class ListMicrosoft365GroupMembersSort {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "Microsoft365GroupMemberSortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMicrosoft365GroupMembersSort.attributeTypeMap;
    }
    constructor() {
    }
}
